/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Month_SnapshotInputs */

const en_directory_launch_month_snapshot = /** @type {(inputs: Directory_Launch_Month_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Month Snapshot`)
};

const zh_directory_launch_month_snapshot = /** @type {(inputs: Directory_Launch_Month_SnapshotInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度概览`)
};

/**
* | output |
* | --- |
* | "Month Snapshot" |
*
* @param {Directory_Launch_Month_SnapshotInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_month_snapshot = /** @type {((inputs?: Directory_Launch_Month_SnapshotInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Month_SnapshotInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_month_snapshot(inputs)
	return zh_directory_launch_month_snapshot(inputs)
});
export { directory_launch_month_snapshot as "directory.launch.month_snapshot" }